export default __webpack_public_path__ + "static/7515-f804dfdc1049d9c88c4a43dacf191c5e.jpg";